import { render, staticRenderFns } from "./listChannelMember.vue?vue&type=template&id=3e90cb0b&"
import script from "./listChannelMember.vue?vue&type=script&lang=js&"
export * from "./listChannelMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports